import request from "@/utils/request";

// 批量生成卡片
export const  batchCard =(data) =>{
    return request({
        url: "/businessservice/card/batchCreate",
        method:"post",
        data: data
    })
}

// 分页查询卡片
export const  pageCard =(data) =>{
    return request({
        url: "/businessservice/card/page",
        method:"post",
        data: data
    })
}

// 查询系统库存卡列表
export const  listStockCard =(query) =>{
    return request({
        url: "/businessservice/card/listStock",
        method:"get",
        params: query
    })
}

// 查询一级代理库存卡列表
export const  listSupplierStockCard =(query) =>{
    return request({
        url: "/businessservice/card/listSupplierStock",
        method:"get",
        params: query
    })
}

// 查询二级代理库存卡列表
export const  listSecondSupplierStockCard =(query) =>{
    return request({
        url: "/businessservice/card/listSecondSupplierStock",
        method:"get",
        params: query
    })
}

// 一级代理卡管理
export const  supplierAddCard =(data) =>{
    return request({
        url: "/businessservice/card/supplierCard",
        method:"post",
        data: data
    })
}

// 二级代理卡管理
export const  secondSupplierAddCard =(data) =>{
    return request({
        url: "/businessservice/card/secondSupplierCard",
        method:"post",
        data: data
    })
}

// 查询库存卡列表
export const  listStockGeneral =(query) =>{
    return request({
        url: "/businessservice/card/listStockGeneral",
        method:"get",
        params: query
    })
}

// 退回卡
export const  backCard =(data) =>{
    return request({
        url: "/businessservice/card/back",
        method:"post",
        data: data
    })
}